import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

const testimonialData = [
  {
    quote: "It is a science and art to build high quality Gen AI solutions. The Informulate team is very skilled in AI/LLM development.",
    name: "Jacques Fu",
    position: "Co-founder @ Stax, CTO @ Worth.ai"
  },
  {
    quote: "The Informulate team is incredible to work with. They have consistently delivered top-notch solutions, and the ongoing partnership is critical to the success of our program",
    name: "Program Manager",
    position: "Global Top 5 University"
  },
  {
    quote: "They have been invaluable, especially as they both put in the time to learn about our strategy and often complex business processes",
    name: "Josh Layne",
    position: "VP @ Maple Street"
  },
  {
    quote: "AI is transforming the way in which companies operate, and businesses require strong partners to support their success. The team at Informulate is outstanding at developing AI technologies to help you succeed.",
    name: "Pete McAlindon",
    position: "CEO @ BlueOrb, Entrepreneur-in-Residence @ Crummer Graduate School"
  },
  {
    quote: "Informulate ramped up quickly on the scope of work, our technology, and the business case. They were able to design the right solution and delivered it with high quality and on budget. I'd highly recommend their expertise.",
    name: "Adam Scheinberg",
    position: "VP @ Massey Services"
  },
  {
    quote: "Over the past 4 years, the Informulate team has gained my organization's trust. Having an expert outside opinion has been successful to plan and strategize in today's fast-paced digital world",
    name: "Sarah Sefcik",
    position: "CTO @ Employment Technologies"
  }
];

export default function TestimonialsMobile() {
  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = testimonialData.length;

  const swiperOptions = {
    modules: [EffectFade, Pagination, Autoplay, Navigation],
    effect: "fade",
    loop: true,
    autoplay: {
      delay: 5500,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".custom-button-next",
      prevEl: ".custom-button-prev",
    },
    onSlideChange: (swiper) => {
      setActiveIndex(swiper.realIndex);
    }
  };

  return (
    <section className="block lg:hidden bg-main-black overflow-hidden">
      <style>
        {`
          .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: rgba(255, 255, 255, 0.5);
            opacity: 1;
            margin: 0 4px !important;
          }
          .swiper-pagination-bullet-active {
            background: #2858b9;
          }
        `}
      </style>
      <div className="py-16">
        <div className="mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block px-5 py-3 mb-5 font-medium leading-none text-white rounded-full bg-purple">
              What Our Clients Say
            </span>
            <h2 className="text-3xl font-semibold text-white">
              Customer Say About Our Services
            </h2>
          </div>

          <div className="relative">
            <Swiper {...swiperOptions} className="w-full testimonial-swiper">
              {testimonialData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="w-full bg-purple rounded-[20px] p-8 relative">
                    <div className="mb-8">
                      <img src="/assets/images/quotation.webp" alt="" />
                    </div>
                    
                    <div className="flex justify-between mb-8">
                      <span className="font-semibold text-white text-lg">
                        {item.name}
                      </span>
                      <div className="flex space-x-2">
                        {[...Array(5)].map((_, i) => (
                          <svg
                            key={i}
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.22953 1.14427C7.95375 -0.381422 10.0462 -0.381425 10.7705 1.14427L12.0221 3.78106C12.3097 4.38691 12.8656 4.80684 13.5087 4.904L16.3074 5.32682C17.9268 5.57148 18.5734 7.64059 17.4016 8.82817L15.3764 10.8806C14.9111 11.3522 14.6988 12.0317 14.8086 12.6976L15.2867 15.5957C15.5633 17.2726 13.8704 18.5514 12.422 17.7596L9.91874 16.3913C9.34357 16.0769 8.65643 16.0769 8.08125 16.3913L5.57799 17.7596C4.12955 18.5514 2.43668 17.2726 2.71331 15.5957L3.19139 12.6976C3.30124 12.0317 3.0889 11.3522 2.62357 10.8806L0.598388 8.82818C-0.57342 7.64059 0.0731955 5.57148 1.69259 5.32682L4.49134 4.904C5.1344 4.80684 5.69031 4.38691 5.9779 3.78106L7.22953 1.14427Z"
                              fill="white"
                            />
                          </svg>
                        ))}
                      </div>
                    </div>

                    <p className="text-xl font-semibold text-white mb-8">
                      {item.quote}
                    </p>
                    <p className="text-sm font-medium text-white/80">
                      {item.position}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex items-center justify-center mt-8 space-x-4">
              <button
                type="button"
                className="custom-button-prev w-[30px] h-[30px] rounded-full flex justify-center items-center bg-purple focus:bg-blue-sass"
              >
                <span>
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                    <path d="M4.75 9L1 5.25M1 5.25L4.75 1.5M1 5.25L11 5.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
              <div className="flex items-center space-x-2">
                {[...Array(totalSlides)].map((_, index) => (
                  <div
                    key={index}
                    className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                      index === activeIndex 
                      ? 'bg-[#2858b9]' 
                      : 'bg-white/50'
                    }`}
                  />
                ))}
              </div>
              <button
                type="button"
                className="custom-button-next w-[30px] h-[30px] rounded-full flex justify-center items-center bg-purple focus:bg-blue-sass"
              >
                <span>
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                    <path d="M7.25 9L11 5.25M11 5.25L7.25 1.5M11 5.25L1 5.25" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 